module.exports = __webpack_public_path__ + "assets/img/home3-box3-img3.ce215df1.png";